import Popover from "bootstrap/js/dist/popover";

export const render = (popoverContainers) => {
  const allowList = Popover.Default.allowList;
  ["table", "tbody", "tr", "td"].forEach((k) => {
    allowList[k] = [];
  });
  popoverContainers.forEach((container) => new Popover(container));
};
